<template>
  <div class="statusBrowsing">
    <box ref="box"></box>
    <el-card shadow="never" :style="style">
      <el-form label-position="right" class="form" :inline="true">
        <el-form-item :label="$t('panelNumber')">
          <el-input-number
            size="mini"
            v-model="searchForm.controllerNo"
            :min="0" :max="254"
            label="描述文字"
          ></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('loopNumber')">
          <el-input-number
            size="mini"
            v-model="searchForm.loopNo"
            :min="0" :max="254"
            label="描述文字"
          ></el-input-number>
        </el-form-item>
        <!-- <el-form-item :label="$t('componentNumber')">
          <el-input-number
            size="mini"
            v-model="searchForm.codeNo"
            :min="0"
            label="描述文字"
          ></el-input-number>
        </el-form-item> -->
        <el-form-item style="float: right">
          <el-button
            style="width: 90px"
            type="primary"
            @click="tooglehandlerBrowse"
            :loading="searching"
          >
            {{ startAndStop !== 'statusBrowsing' ? $t('queryButton') : $t('stop') }}
          </el-button>
        </el-form-item>
      </el-form>
      <div class="tag">
        <span
          class="item"
          :class="{ active: currentIndex === index }"
          :key="index"
          @click="changeTable(index)"
          v-for="(item, index) in shortcutList"
          >{{ item.name }}</span
        >
      </div>
      <div v-show="!showTable" id="main" ref="chart" style="width: 100%"></div>
      <div v-show="showTable">
        <specialTable :tableArray="tableArray" :toolTipObj="codeToDescr"></specialTable>
      </div>
    </el-card>
  </div>
</template>

<script>
import BasePage from "@/components/BasePage";
import * as echarts from "echarts";
import Box from "@/components/Box";
import specialTable from "./table.vue";
import { getLoopSignal, stop, getTypeDescr } from "@/api/query";
import Status from "components/Status";
var data = generateData();
console.log(data)
const codeToDescr = {}
var option = {
  title: {
    left: 10,
  },
  toolbox: {
    feature: {
      dataZoom: {
        yAxisIndex: false,
      },
      saveAsImage: {
        pixelRatio: 2,
      },
    },
  },
  // tooltip :{
  //   show: true,
  //   showContent: true,
  //   trigger: 'item', //坐标轴触发，可设为 item 数据项图形触发
  //   // confine: true, //将 tooltip 框限制在图表的区域内，在移动端开发时非常有用
  //   // formatter 设置提示的文字内容（需要改变样式可通过 rich 富文本实现，见文档），要在 tooltip 中显示单位，可通过函数 params 拼字符串加上如下面 % 的单位
  //   formatter: function(params){
  //     // let index = params.dataIndex
  //     // let descr = this.codeToDescr[index - 1].descr
  //     // let devType = this.codeToDescr[index - 1].devType
  //     console.log(params.dataIndex)
  //     // return `注释: ${descr} \n 设备类型: ${devType}`
  //     // return params
  //     return params.dataIndex
  //   }
  // },
   tooltip: {
        trigger: 'axis',
        axisPointer: {// 坐标轴指示器，坐标轴触发有效
            type: 'shadow'// 默认为直线，可选为：'line' | 'shadow'
        },
        formatter: function(params){
          // console.log(params[0].dataIndex)
          let index = params[0].dataIndex
          let descr = codeToDescr[index] ? codeToDescr[index.descr] : false
          let devType = codeToDescr[index] ? codeToDescr[index].devType : false
          let codeNo = index
          let str = codeNo + (descr ? (" " + descr) : "") + (devType ? (" " + devType) : "")
          return str
         ///return params
         //return params.dataIndex
    }
    },
  grid: {
    bottom: 90,
  },
  dataZoom: [
    {
      type: "inside",
    },
    {
      type: "slider",
    },
  ],
  xAxis: {
    data: data.categoryData,
    silent: false,
    splitLine: {
      show: false,
    },
    splitArea: {
      show: false,
    },
    type:'category',
  },
  yAxis: {
    max: 30,
    splitArea: {
      show: false,
    },
    type: 'value'
  },
  series: [
    {
      type: "bar",
      data: data.valueData,
      // Set `large` for large data amount
      large: true,
    },
  ],
};

function generateData () {
  var categoryData = [];
  var valueData = [];

  for (var i = 0; i < 255; i++) {
    categoryData.push(i);
    valueData.push(0);
  }
  return {
    categoryData: categoryData,
    valueData: valueData,
  };
}
export default {
  name: "statusBrowsing",
  mixins: [BasePage, Status],
  components: {
    Box,
    specialTable
  },
  data() {
    return {
      searchForm: {
        controllerNo: 1,
        loopNo: 1,
        // codeNo: 1,
      },
      tabClickIndex: null,
      bottomHeight: null,
      clicked: true,
      tabClickLabel: "",
      oldControllerNotes: "",
      showTable: false,
      currentIndex: 0,
      shortcutList: [
        {
          name: "图表",
        },
        {
          name: "列表",
        },
      ],
      getLoopSignal: getLoopSignal,
      requestData: {},
      myChart: null,
      tableArray: [],
      style: null,
      searching: false,
      id:"",
      codeToDescr:{
        // 1:{
        //   descr: "测试",
        //   devType:"测试devType"
        // },
        // 2:{
        //   descr: "测试22",
        //   devType:"测试devType22"
        // },
        // 3:{
        //   descr: "测试33",
        //   devType:"测试devType33"
        // },
      }
    };
  },
  computed:{
    deviceType(){
      let list = this.$store.state.deviceTypeOptions
      return this.codeToName(list, "code", "name");
    },
    startAndStop:{
      get(){
        return this.$store.state.startAndStop
      },
      set(val){
        this.$store.commit('changeStartAndStop', val);
      }
    },
    responseErrFlag(){
      return this.$store.state.responseErrFlag
    }
  },
  created(){
    this.searchForm.controllerNo = this.$store.state.controlInfo.controllerNo
  },
  mounted() {
    this.calcHeight()
    let dom = this.$refs.chart;
    let offsetTop = 0; // 顶部偏移量
    let el = dom;
    while (el.offsetParent) {
      offsetTop += el.offsetTop;
      el = el.offsetParent;
    }
    let innerHeight = window.innerHeight;
    dom.style.height = innerHeight - offsetTop - 30 + "px";
    this.myChart = echarts.init(document.getElementById("main"));
    console.log(option)
    this.myChart.setOption(option, true);
    this.tableArray = this.Generate2Darray();
    //
  },
  methods: {
    codeToName(list, key, name){
      let res = {}
      list.forEach(v => {
        if (!res[v[key]]) {
          res[v[key]] = v[name];
        }
      })
      return res
    },
    getDescrAndType(){
      const { sysSetting } = this.$store.state;
      const params = {
        controllerPsn: sysSetting.controllerPsn,
        // controllerPsn: "C980098EABBD236A" || sysSetting.controllerPsn || '',
        controllerNo: this.searchForm.controllerNo, //控制器号
        loopNo: this.searchForm.loopNo, //回路号
      }
      getTypeDescr(params).then(res => {
        if (res.code === 1) {
          res.data.forEach(v => {
            this.codeToDescr[v.codeNo] = {
              devType: this.deviceType[v.devType],
              descr: v.descr,
              codeNo: v.codeNo,
            }
          })
        }
      }).catch(err => console.log(err))
    },
    calcHeight() {
      setTimeout(() => {
        this.bottomHeight = this.$refs.box.$el.clientHeight + 'px'
        this.style = `height: calc(100vh - 100px - ${this.bottomHeight})`
      }, 20)
    },
    handleChange(value) {
      console.log(value);
    },
    changeTable(index) {
      this.currentIndex = index;
      this.showTable = !this.showTable;
      let newVal = this.$store.state.currentLoopStatus;
      // if (this.startAndStop) return
      if (this.showTable) {
        this.tableArray = newVal.dataUint ? this.dataToTable(newVal.dataUint.data) : this.Generate2Darray();
      } else {
        option = newVal.dataUint ? this.dataToEcharts(newVal) : option;
        this.myChart.setOption(option, true);
      }
    },
    getRows() {
      this.rows = [];
    },
    tooglehandlerBrowse() {
      const { sysSetting } = this.$store.state;
      const params = {
        controllerPsn: sysSetting.controllerPsn,
        // controllerPsn: "C980098EABBD236A" || sysSetting.controllerPsn || '',
        controllerNo: this.searchForm.controllerNo, //控制器号
        loopNo: this.searchForm.loopNo, //回路号
        codeNo: this.searchForm.codeNo, //部位号
        signalType: this.showTable ? 2 : 1, // 1：坐标轴，2：表格
      };
      const stopParams = {
        controllerPsn: sysSetting.controllerPsn,
        id: this.id
      }
      this.startAndStop !== 'statusBrowsing' ? this.handlerBrowse(params) : this.stopBrowse(stopParams);
    },
    stopBrowse(params) {
      this.searching = true;
      stop(params).then((res) => {
        this.searching = false;
        if (res.data) {
          console.log("停止响应");
          this.requestData = {};
          this.$store.commit('changeStartAndStop', "");
          sessionStorage.startAndStop = ""
          data = generateData();
          option.xAxis.data = data.categoryData
          option.series[0].data = data.valueData
          if (this.myChart) {
            this.myChart.setOption(option, true)
          }
          this.tableArray = this.Generate2Darray();
          this.codeToDescr = {}
        }
      }).catch(() => {
        this.searching = false;
        // this.$store.commit('changeStartAndStop', "statusBrowsing");
        // sessionStorage.startAndStop = "statusBrowsing"
        // this.$message.error(err.message)
      });
    },
    handlerBrowse(params) {
      this.getDescrAndType()
      if (this.startAndStop !== '') {
        this.$message.warning("命令阻塞中!")
        return
      }
      this.searching = true;
      this.show()
      getLoopSignal(params)
        .then((res) => {
          if (res.code === 1) {
            this.id = res.data.id;
            this.requestData = JSON.parse(JSON.stringify(res.data));
            this.success(res.message ? res.message : '操作成功')
            this.$store.commit('changeStartAndStop', "statusBrowsing");
            sessionStorage.startAndStop = "statusBrowsing"
          }
        })
        .catch(() => {
          this.searching = false;
          // this.$store.commit('changeStartAndStop', "");
          // sessionStorage.startAndStop = ""
          // this.failed()
        });
    },
    Generate2Darray() {
      let resArr = [];
      for (let i = 0; i < 14; i++) {
        let rowArr = [];
        for (let j = 0; j < 21; j++) {
          let rowNum =
            i < 2
              ? j < 1
                ? ""
                : i < 1
                ? j - 1
                : ""
              : j < 1
              ? (i - 1) * 20
              : "";
          rowArr.push(rowNum);
          // rowArr.push(3);
        }
        resArr.push(rowArr);
      }
      return resArr;
    },
    dataToTable(arr) {
      if (!arr.length) return
      let table2DArr = this.Generate2Darray();
      for (let i in arr) {
        let value = arr[i];
        let firstIndex = Math.floor(i / 20) + 1;
        let secondIndex = (i % 20) + 1;
        table2DArr[firstIndex][secondIndex] = (value).toString(16);
      }
      return table2DArr;
    },
    dataToEcharts(newVal) {
      // 0~2 故障 12~30 报警
      let self = this;
      let colorList = [];
      option.xAxis.data = this.generateX(newVal.dataUint.data.length);
      // newVal.dataUint.data.forEach((v, i) => {
      //   // colorList[i] = (v > 0 && v <= 2) ? 'yellow' : (v > 2 && v <= 12) ? 'red' : "red"
      //   colorList[i] = (v > 0 && v <= 2) ? "yellow" : (v > 2 && v <= 12) ? "#5470c6" : "red";
      // });
      let colorData = []
      newVal.dataUint.data.forEach(v => {
        let val = v / 5
        let style = "#5470c6"
        if ((val > 0 && val <= 2) || val > 30){
            style = "#f4e000"
        } else if (val > 12 && val < 30){
            style = "#red"
        }

        let obj = {
          value: val,
          itemStyle: {
            color: style
          }
        }
        colorData.push(obj)
      })
      option.tooltip = {
         trigger: 'axis',
         axisPointer: {// 坐标轴指示器，坐标轴触发有效
         type: 'shadow',// 默认为直线，可选为：'line' | 'shadow'
        },
        formatter: function(params){
          console.log(params[0].dataIndex)
          let index = params[0].dataIndex
          let descr = self.codeToDescr[index] ? self.codeToDescr[index].descr : false
          let devType = self.codeToDescr[index] ? self.codeToDescr[index].devType : false
          // console.log(devCode)
          // let devType = devCode ? self.deviceType[devCode] : false
          let codeNo = index
          let str = codeNo + (descr ? (" " + descr) : "") + (devType ? (" " + devType) : "")
          return str
      ///return params
      //return params.dataIndex
    }
      }
      option.series[0].data = colorData;
      option.color = colorList;
      return option;
    },
    generateX(length) {
      let res = [];
      for (let i = 0; i < length; i++) {
        res.push(i);
      }
      return res;
    },
    init_data(){
      this.searching = false;
      this.id = ""
      this.$store.commit('setCurrentLoopStatus', {});
      data = generateData();
      option.xAxis.data = data.categoryData
      option.series[0].data = data.valueData
      if (this.myChart) {
        this.myChart.setOption(option, true)
      }
      this.tableArray = this.Generate2Darray();
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log('进入路由')
    next(vm => {
      if (vm.$store.state.responseErrFlag) {
        vm.searching = false;
        vm.id = ''
        data = generateData();
        option.xAxis.data = data.categoryData
        option.series[0].data = data.valueData
        if (vm.myChart) {
          vm.myChart.setOption(option, true)
        }
        vm.tableArray = vm.Generate2Darray();
      }
    })
  },

  watch: {
    "$store.state.currentLoopStatus": {
      handler(newVal) {
        if (newVal && newVal.request.id !== this.id) return
        if (!newVal.dataUint) return
        this.failed()
        this.searching = false;
        if (this.showTable) {
          this.tableArray = this.dataToTable(newVal.dataUint.data);
        } else {
          option = this.dataToEcharts(newVal);
          this.myChart.setOption(option, true);
        }
        // if (newVal.dataUint.signalType === 1) { // 坐标
        // } else if (newVal.signalType === 2) { // 表格
        //   this.dataToTable(newVal.loopSingal)
        // }
      },
      deep: true,
    },
    responseErrFlag(newVal){
      if (newVal) {
        this.failed();
        // let status = this.$store.state.startAndStop
        // console.log(status,"startAndStop")
        // this.$store.commit('changeStartAndStop', status);
        // sessionStorage.startAndStop = status
        this.loading = false
        this.init_data();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.statusBrowsing {
  .tag {
    margin-bottom: 10px;
    background-color: #f5f7fa;
    width: 120px;
    border-radius: 15px;
    .item {
      color: #606266;
      display: inline-block;
      width: 60px;
      height: 30px;
      border-radius: 15px;
      text-align: center;
      line-height: 30px;
    }
    .active {
      background-color: #74dcff;
      color: #ffffff;
    }
  }
}
</style>
